import { CONDUCTOR_RELEASES } from '../../constants';
import type { ConductorReleaseId, TABCString } from '../../services/conduct';

export type ReleasesSlice = Record<ConductorReleaseId, TABCString>;

export const getReleasesInitialState = (): ReleasesSlice => ({
  [CONDUCTOR_RELEASES.ENABLE_ANONYMOUS_AI_CHATBOT]: 'A',
});
